module.exports = __webpack_public_path__ + "static/media/canopy.702d987f.png";